export const getRoleTranslationString = (role: string): string => `permissions.roles.${role.replace(/:/g, '-')}`;
